import React from "react";
import { StyleSheet, View } from "react-native";

import { BottomSheet } from "@rneui/base";
import Text from "./text";
import Button from "./button";
import translate from "../libs/locale";
import { ImageMapper } from "../assets/images";
import { Image } from "./image";

export default function OTPDialog({
  open,
  title,
  message,
  error,
  onOk,
  close,
}: {
  open: boolean;
  title: string;
  message: React.JSX.Element;
  error: boolean;
  onOk: () => void;
  close: () => void;
}) {
  return (
    <BottomSheet
      modalProps={{ animationType: "fade" }}
      isVisible={open}
      onBackdropPress={close}
      scrollViewProps={{ scrollEnabled: false }}
    >
      <View style={styles.root}>
        <View style={styles.titleContainer}>
          <Text style={styles.title}>{title}</Text>
          <Button solid={false} onPress={close} style={styles.close}>
            <Image source={ImageMapper.Close} style={styles.closeIcon} />
          </Button>
        </View>
        {message}
        <Button
          text={translate("ok")}
          onPress={onOk}
          style={[styles.ok, error && { backgroundColor: "#F4857F" }]}
        />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  root: {
    backgroundColor: "#fff",
    paddingHorizontal: 20,
    paddingVertical: 31,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },
  close: {
    position: "absolute",
    right:0,
    top: -10
  },
  closeIcon: {
    height: 13,
    width: 13,
  },
  titleContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  ok: {
    width: 89,
    height: 50,
    backgroundColor: "#00AEB4",
    alignSelf: "center",
    marginTop: 36,
  },
  title: {
    color: "#364650",
    fontFamily: " MontserratBold",
    fontSize: 20,
  },
});
